import { observable } from 'mobx';
import type { FlightSegmentTerminalResponseArgs } from './flight_segment_terminal';
import FlightSegmentTerminal, { convertFlightSegmentTerminalResponseToArgs } from './flight_segment_terminal';
import type { AirRouteDetailResponseArgs } from './air_route_detail';
import AirRouteDetail, { convertAirRouteDetailResponseToArgs } from './air_route_detail';

export type FlightSegmentResponseArgs = {
  from: FlightSegmentTerminalResponseArgs;
  to: FlightSegmentTerminalResponseArgs;
  carrier_name: string;
  name: string;
  cabin: string;
  air_route_detail?: AirRouteDetailResponseArgs;
};

export type FlightSegmentArgs = {
  from: FlightSegmentTerminal;
  to: FlightSegmentTerminal;
  carrierName: string;
  name: string;
  cabin: string;
  airRouteDetail?: AirRouteDetail;
};

export const convertFlightSegmentResponseToArgs = (response: FlightSegmentResponseArgs) => {
  const args: FlightSegmentArgs = {
    from: new FlightSegmentTerminal(convertFlightSegmentTerminalResponseToArgs(response.from)),
    to: new FlightSegmentTerminal(convertFlightSegmentTerminalResponseToArgs(response.to)),
    carrierName: response.carrier_name,
    name: response.name,
    cabin: response.cabin,
    airRouteDetail: response.air_route_detail
      ? new AirRouteDetail(convertAirRouteDetailResponseToArgs(response.air_route_detail))
      : undefined
  };
  return args;
};

export default class FlightSegment {
  @observable from: FlightSegmentTerminal;
  @observable to: FlightSegmentTerminal;
  @observable carrierName: string;
  @observable name: string;
  @observable cabin: string;
  @observable airRouteDetail?: AirRouteDetail;

  constructor(args: FlightSegmentArgs) {
    this.from = args.from;
    this.to = args.to;
    this.carrierName = args.carrierName;
    this.name = args.name;
    this.cabin = args.cabin;
    this.airRouteDetail = args.airRouteDetail;
  }
}
